import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  typography: {
    fontFamily: "'Source Sans 3', sans-serif",
  },
  palette: {
    primary: {
      main: '#1565C0', // professional blue
      light: '#1E88E5',
      dark: '#0D47A1',
    },
    background: {
      default: '#F5F7FA',
      paper: '#FFFFFF',
    },
    text: {
      primary: '#1A1A2E',
      secondary: '#5A6A85',
    }
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontFamily: "'Source Sans 3', sans-serif",
          fontWeight: 600,
        }
      }
    }
  }
});

export default theme;